module.exports = "/_next/static/images/61c88226d2420bfc7f0f8691789bc55f-mgm-invite-ticket-6.jpg";